import React from 'react'

export default function WebDesignIcons() {
   return (
      <svg
         width="64"
         height="64"
         viewBox="0 0 64 64"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M43.5599 57.55C42.9999 58.46 42.0299 59 40.9499 59H23.0498C21.9698 59 20.9999 58.46 20.4399 57.55C19.8999 56.66 19.8499 55.58 20.3299 54.65L22.1899 51H41.8099L43.6698 54.65C44.1498 55.58 44.0999 56.66 43.5599 57.55Z"
            fill="#1F473E"
         />
         <path
            d="M31 10H9C7.89543 10 7 10.8954 7 12V22C7 23.1046 7.89543 24 9 24H31C32.1046 24 33 23.1046 33 22V12C33 10.8954 32.1046 10 31 10Z"
            fill="#1F473E"
         />
         <path
            d="M17 26H9C7.89543 26 7 26.8954 7 28V36C7 37.1046 7.89543 38 9 38H17C18.1046 38 19 37.1046 19 36V28C19 26.8954 18.1046 26 17 26Z"
            fill="#1F473E"
         />
         <path
            d="M31 26H23C21.8954 26 21 26.8954 21 28V36C21 37.1046 21.8954 38 23 38H31C32.1046 38 33 37.1046 33 36V28C33 26.8954 32.1046 26 31 26Z"
            fill="#1F473E"
         />
         <path
            d="M56 38H41C40.45 38 40 37.55 40 37C40 36.45 40.45 36 41 36H56C56.55 36 57 36.45 57 37C57 37.55 56.55 38 56 38ZM56 33H41C40.45 33 40 32.55 40 32C40 31.45 40.45 31 41 31H56C56.55 31 57 31.45 57 32C57 32.55 56.55 33 56 33ZM56 28H41C40.45 28 40 27.55 40 27C40 26.45 40.45 26 41 26H56C56.55 26 57 26.45 57 27C57 27.55 56.55 28 56 28Z"
            fill="#1F473E"
         />
         <path
            d="M57 5H7C4.24 5 2 7.24 2 10V44C2 46.76 4.24 49 7 49H57C59.76 49 62 46.76 62 44V10C62 7.24 59.76 5 57 5ZM4 41V10C4 8.35 5.35 7 7 7H35V41H4ZM60 41H37V7H57C58.65 7 60 8.35 60 10V41Z"
            fill="#1F473E"
         />
         <path
            d="M52.9996 20.9999C52.7896 20.9999 52.5796 20.9299 52.3996 20.7999C51.9596 20.4699 51.8696 19.8399 52.1996 19.3999L54.7496 15.9999L52.1996 12.5999C51.8696 12.1599 51.9596 11.5299 52.3996 11.1999C52.8396 10.8699 53.4696 10.9599 53.7996 11.3999L56.7996 15.3999C57.0696 15.7599 57.0696 16.2399 56.7996 16.5999L53.7996 20.5999C53.5996 20.8599 53.2996 20.9999 52.9996 20.9999ZM42.9996 20.9999C42.6996 20.9999 42.3996 20.8599 42.1996 20.5999L39.1996 16.5999C39.0682 16.4275 38.9971 16.2167 38.9971 15.9999C38.9971 15.7831 39.0682 15.5723 39.1996 15.3999L42.1996 11.3999C42.5296 10.9599 43.1596 10.8699 43.5996 11.1999C44.0396 11.5299 44.1296 12.1599 43.7996 12.5999L41.2496 15.9999L43.7996 19.3999C44.1296 19.8399 44.0396 20.4699 43.5996 20.7999C43.4196 20.9299 43.2096 20.9999 42.9996 20.9999ZM46.9996 20.9999C46.9196 20.9999 46.8396 20.9999 46.7596 20.9699C46.5025 20.9061 46.2811 20.7428 46.1443 20.5159C46.0074 20.2891 45.9662 20.0172 46.0296 19.7599L48.0296 11.7599C48.1014 11.5116 48.2665 11.3006 48.4904 11.1714C48.7143 11.0422 48.9795 11.0047 49.2305 11.0668C49.4814 11.1289 49.6986 11.2857 49.8364 11.5044C49.9742 11.7232 50.0219 11.9867 49.9696 12.2399L47.9696 20.2399C47.8596 20.6999 47.4496 20.9999 46.9996 20.9999Z"
            fill="#1F473E"
         />
      </svg>
   )
}
